export default __webpack_public_path__ + "static/media/Datorsal5.9e68672d.jpeg";